const translation = {
  // ServerCard.tsx
  ServerCard: {
    gpu_model: 'GPU 型号',
    gpu_count: 'GPU 数量',
    cpu_count: 'CPU 核数',
    cpu_model: 'CPU 型号',
    cpu_arch: 'CPU 架构',
    memory: '内存',
    gpu_memory: '显存',
    system_disk: '系统盘',
    data_disk: '数据盘',
    cuda_version: 'CUDA 版本',
    gpu_flops: '浮点算力',
    area: '可用地区',
    buy: '快速购买',
    rentable: '{{count}} 卡可租',
    available_more: '资源充足',
    available_few: '资源紧张',
    available_no: '已授权',
    createContainer: '创建容器实例',
    createTask: '创建训练任务',
    createServer: '创建推理服务',
    ENOUGH: '资源充足',
    SURGING: '资源紧张',
    SOLD_OUT: '售罄',
    pricePerHour: '元/时',
  },

  // Status.tsx
  Status: {
    ready: '就绪',
    ok: '正常',
    success: '成功',
    running: '运行中',
    creating: '创建中',
    error: '错误',
    starting: '启动中',
    stopping: '停止中',
    pending: '等待中',
    queuing: '排队中',
    stopped: '已停止',
    init: '初始化',
    failed: '失败',
    warning: '异常',
    online: '在线',
    offline: '离线',
    open: '开启',
    close: '关闭',
    unknown: '未知',
    closing: '关闭中',
    importing: '导入中',
    published: '已发布',
    scaling: '扩容中',
  },

  gitImport: {
    failureTitle: 'Git 导入失败',
    failureHint: '请根据以下说明检查仓库地址、网络与权限后重新导入。',
    viewReason: '查看失败原因',
    logTailLabel: '任务日志（尾部）',
  },

  // ResourceSpecForm.tsx
  ResourceSpecForm: {
    name: '名称',
    gpu_name: 'GPU型号',
    gpu_key: 'GPU标识',
    gpu_num: 'GPU数量',
    gpu_mem: 'GPU显存',
    cpu_num: 'CPU核心数',
    cpu_name: 'CPU型号',
    cpu_arch: 'CPU架构',
    mem_size: '内存大小',
    extras: '其它资源',
  },

  // ResourceQuotaForm.tsx
  ResourceQuotaForm: {
    project: '项目',
    queue: '资源队列',
    expired_at: '到期时间',
    confirm: '确定',
    cancel: '取消',
    user: '用户',
    userTooltip: '选择要分配资源配额的目标用户',
  },

  // ResourceGroupForm.tsx
  ResourceGroupForm: {
    name: '名称',
    description: '描述',
    confirm: '确定',
    cancel: '取消',
  },

  // ImageList.tsx
  ImageList: {
    delete_success: '删除成功！',
    delete_failed: '删除失败！',
    confirm_delete: '确认删除',
    confirm_delete_content: '确认删除该镜像？',
    confirm: '确认',
    cancel: '取消',
    nameAndId: '名称 / ID',
    tags: '标签',
    registry: '镜像仓库',
    usage: '镜像用途',
    status: '状态',
    permission: '权限',
    created_at: '创建/更新时间',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    operation: '操作',
    edit: '编辑',
    export: '导出',
    import: '导入',
    delete: '删除',
    export_copied: '导出命令已复制到剪贴板！',
    import_copied: '导入命令已复制到剪贴板！',
    create_image: '创建镜像',
  },

  // TrainingTaskForm.tsx
  TrainingTaskForm: {
    name: '名称',
    permission: '权限',
    description: '描述',
    resource: '训练资源',
    framework: '训练框架',
    environment: '训练环境',
    base_model: '基础模型',
    model_version: '模型版本',
    training_data: '训练数据',
    dataset_version: '数据集版本',
    volume_mounts: '挂载存储',
    working_dir: '工作目录',
    cmd: '启动命令',
    args: '启动参数',
    env: '环境变量',
    restart_policy: '重启策略',
    restart_count: '重启次数',
    output_model: '输出模型',
    output_model_name: '输出模型名称',
    model_path: '模型路径',
    confirm: '确定',
    cancel: '取消',
    save_template: '保存为模板',
    template_name: '模板名称',
    template_name_required: '模板名称不能为空',
  },

  // DeploymentForm.tsx
  DeploymentForm: {
    service_name: '服务名称',
    service_type: '服务类型',
    deployment_permission: '部署权限',
    deployment_resource: '部署资源',
    storage_mount: '存储挂载',
    deployment_model: '部署模型',
    deployment_model_version: '部署模型版本',
    inference_image: '推理镜像',
    working_dir: '工作目录',
    cmd: '启动命令',
    args: '启动参数',
    env: '环境变量',
    confirm: '确定',
    cancel: '取消',
  },

  // DeploymentList.tsx
  DeploymentList: {
    id_name: '名称 / ID',
    status: '状态',
    permission: '权限',
    model: '模型',
    image: '镜像',
    resource_info: '资源信息',
    replicas: '副本',
    created_at: '创建/更新时间',
    access_entry: '访问入口',
    access_service: '访问服务',
    set_model: '设置模型',
  },

  // InstanceForm.tsx
  InstanceForm: {
    instance_name: '实例名称',
    resource_selection: '资源选择',
    volume_mounts: '挂载存储',
    container_image: '容器镜像',
    working_dir: '工作目录',
    cmd: '启动命令',
    args: '启动参数',
    env: '环境变量',
    port_mapping: '端口映射',
    confirm: '确定',
    cancel: '取消',
    updateInstance: '更新实例',
    createInstance: '创建实例',
  },

  // GitRepoModal.tsx
  GitRepoModal: {
    modal: 'Modal',
    confirm: '确认',
    cancel: '取消',
  },

  // Money.tsx
  Money: {
    cny: '元',
    usd: '美元',
  },

  // ImageUsage.tsx
  ImageUsage: {
    ecs: 'ECS',
    train: '训练',
    deploy: '推理',
    all: '通用',
  },

  // DeploymentScaleBtn.tsx
  DeploymentScaleBtn: {
    scale_capacity: '调整容量',
    scale_success: '调整容量成功！',
    scale_failed: '调整容量失败！',
    scale_title: '调整容量',
    replicas_count: '推理服务副本数量：',
  },

  // BillingMode.tsx
  BillingMode: {
    payg: '按量计费',
  },

  // ResourceSelectorDesc.tsx
  ResourceSelectorDesc: {
    unknown: '未知',
    view: '查看',
    dash: '--',
  },

  // ChangeImageBtn.tsx
  ChangeImageBtn: {
    change_image: '更换镜像',
    image: '镜像',
    confirm: '确定',
    success: '更换镜像成功！',
    failed: '更换镜像失败！',
  },

  // RechargeBtn.tsx
  RechargeBtn: {
    recharge_now: '立即充值',
    account_recharge: '账户充值',
  },
  // DataUsagePie.tsx
  dataUsagePie: {
    used: '已使用',
  },
  // UserSelect.tsx
  userSelect: {
    placeholder: '选择用户',
  },
  // ServerForm.tsx
  serverForm: {
    userTenantId: '用户租户ID',
  },
  // ResourceSelector.tsx
  ResourceSelector: {
    billing_mode: '计费方式',
    payg: '按量计费',
    reserved_day: '包日',
    reserved_week: '包周',
    available_region: '可用地区',
    resource_cluster: '资源集群',
    resource_queue: '资源队列',
    resource_spec: '资源规格',
    instance_count: '实例数量',
    // 验证错误消息
    resource_required: '资源不能为空',
    billing_mode_required: '计费方式不能为空',
    region_required: '地区不能为空',
    cluster_required: '资源集群不能为空',
    queue_required: '资源队列不能为空',
    resource_spec_required: '资源规格不能为空',
    instance_count_required: '实例数量不能为空',
  },

  // 通用操作
  common: {
    confirm: '确定',
    cancel: '取消',
    edit: '编辑',
    delete: '删除',
    create: '创建',
    update: '更新',
    save: '保存',
    export: '导出',
    import: '导入',
    view: '查看',
    unknown: '未知',
    success: '成功',
    failed: '失败',
    error: '错误',
    warning: '警告',
    info: '信息',
    deleteFile: '删除文件',
    deleteFileConfirm: '确定删除该文件吗？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    search: '搜索',
  },

  label: {
    idOrName: '名称 / ID',
    tag: '标签',
    status: '状态',
    permission: '权限',
    storageDisk: '磁盘存储',
    doc: '文档',
    createdOrUpdatedAt: '创建/更新时间',
    action: '操作',
    publicDataset: '数据集',
    detail: '详情',
    version: '版本',
    file: '文件',
    directory: '目录',
    datasetDetail: '数据集详情',
    createDataset: '创建数据集',
    datasetName: '数据集名称',
    datasetDescription: '数据集描述',
    storageDiskTip: '选择用于存放数据集文件的存储磁盘',
    datasetPath: '数据集路径',
    datasetPathTip: '数据集在磁盘中的相对路径或 S3 路径，例如：datasets/my-dataset',
    datasetPermission: '数据集权限',
    datasetDoc: '数据集文档',
    datasetDocUrlTip: '数据集相关的文档或说明链接地址，便于其他用户了解数据集的格式和使用方法',
    createDisk: '创建磁盘',
    diskDetail: '详情',
    unknown: '未知',
    alias: '别名',
    storageCluster: '存储集群',
    size: '大小',
    readOnly: '只读',
    yes: '是',
    no: '否',
    user: '用户',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    project: '项目',
    sizeLimit: '磁盘大小限制',
    path: '路径',
    pathTip: '磁盘所在存储路径，如果不填写则系统自动生成',
    readOnlyTip: '是否对他人只读',
    readOnlyCheckbox: '是否对他人只读',
    selectDisk: '选择存储磁盘',
    用户磁盘: '用户磁盘',
    公共模型: '公共模型',
    diskFiles: '文件',
    pageInfo: '第 {{current}} 页 / 共 {{total}} 页',
  },
  action: {
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    uploadFile: '上传文件',
    edit: '编辑',
    publish: '发布',
    import: '导入',
    delete: '删除',
    createDataset: '创建数据集',
    viewDoc: '查看文档',
    editDataset: '编辑数据集',
    deleteDisk: '删除磁盘',
    updateDisk: '更新磁盘',
    createDisk: '创建磁盘',
    download: '下载',
    preview: '预览',
    confirm: '确认',
    cancel: '取消',
    prevPage: '上一页',
    nextPage: '下一页',
  },
  StorageList: {
    fileName: '文件名称',
    extension: '扩展名',
    size: '大小',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    operation: '操作',
    uploadFile: '上传文件',
    download: '下载',
    delete: '删除',
  },
  placeholder: {
    search: '搜索',
    relativePath: '数据集在磁盘中的相对路径',
    selectVersion: '请选择版本',
  },
  msg: {
    importSuccess: '已提交导入任务',
    importError: '导入失败',
    selectStorageDisk: '请选择存储磁盘',
    inputDatasetPermission: '请输入数据集权限',
    inputDatasetDocUrl: '请输入数据集文档URL地址',
    confirmDeleteFile: '确认删除文件',
    cannotUndo: '此操作无法撤销',
    previewNotSupported: '当前仅支持预览图片、PDF 和 CSV 文件',
    previewFail: '预览文件失败',
    pdfLoadFail: '加载 PDF 失败',
    csvLoadFail: '加载 CSV 文件失败',
    csvEmpty: 'CSV 文件为空',
    csvTotalRows: '共 {{total}} 行',
  },
  modelForm: {
    label: {
      name: '模型名称',
      description: '模型描述',
      disk: '存储磁盘',
      path: '模型路径',
      permission: '模型权限',
      docUrl: '模型文档',
    },
    tooltip: {
      name: '模型的唯一标识名称，用于在系统中识别和引用该模型',
      description: '对模型用途、特点等信息的简要描述，便于后续查找和管理',
      path: '模型在磁盘中的相对路径，例如：models/my-model-v1',
      permission: '设置模型的访问权限：私有仅自己可见，公开则项目内所有成员可见',
      docUrl: '模型相关的文档或说明链接地址，便于其他用户了解模型的使用方法',
    },
    msg: {
      selectDisk: '请选择存储磁盘',
      inputPermission: '请输入模型权限',
      inputDocUrl: '请输入模型文档地址',
    },
    placeholder: {
      path: '模型在磁盘中的相对路径',
    },
    action: {
      confirm: '确定',
      cancel: '取消',
    },
    args: {
      nameRequired: '参数名称不能为空',
      namePlaceholder: '启动参数名称',
      descPlaceholder: '启动参说明',
      valuePlaceholder: '启动参数值',
    },
  },
  modelList: {
    label: {
      idName: '名称 / ID',
      tags: '标签',
      status: '状态',
      permission: '权限',
      disk: '存储磁盘',
      trainDetail: '训练详情',
      doc: '文档',
      createUpdateTime: '创建/更新时间',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      action: '操作',
    },
    action: {
      view: '查看',
      edit: '编辑',
      publish: '发布',
      import: '导入',
      delete: '删除',
      create: '创建模型',
    },
    import: {
      title: '导入模型',
      placeholder: '请输入 Git 仓库地址',
      msg: {
        inputGitUrl: '请输入 Git 仓库地址',
      },
      success: '导入成功',
    },
  },
  modelSelector: {
    placeholder: {
      selectModel: '选择模型',
    },
  },
  modelVersionList: {
    label: {
      name: '名称',
      created: '创建时间',
      action: '操作',
    },
    action: {
      delete: '删除',
    },
  },
  modelVersionSelector: {
    placeholder: {
      selectVersion: '请选择版本',
    },
  },
  repository: {
    title: '镜像仓库',
    detailTitle: '镜像仓库详情',
    createTitle: '新建镜像仓库',
    create: '创建镜像仓库',
    nameAndId: '名称 / ID',
    permission: '权限',
    registry: '仓库地址',
    namespace: '命名空间',
    username: '仓库账号',
    password: '仓库密码',
    quota: '配额',
    hosted: '平台分配镜像仓库（按量计费），配额：',
    harbor_url: '托管地址',
    created_at: '创建时间',
    operation: '操作',
    delete: '删除',
    confirmDelete: '确认删除该仓库？',
    searchPlaceholder: '搜索',
    description: '描述',
    confirm: '确定',
    cancel: '取消',
    view: '查看',
    edit: '编辑',
    editTitle: '编辑镜像仓库',
  },
  image: {
    title: '容器镜像',
    createTitle: '创建镜像',
    detailTitle: '镜像详情',
    editTitle: '编辑',
    saveTitle: '保存',
    id: 'ID',
    tags: '标签',
    registry: '仓库地址',
    usage: '镜像用途',
    size: '大小',
    created_at: '创建时间',
    operation: '操作',
    delete: '删除',
    confirmDelete: '确认删除该镜像？',
    confirm: '确定',
    cancel: '取消',
    view: '查看',
    name: '镜像名称',
    tag: '镜像标签',
    description: '镜像说明',
    working_dir: '工作目录',
    cmd: '启动命令',
    args: '启动参数',
    dockerfile: 'Dockerfile',
    permission: '镜像权限',
    is_third: '第三方公开镜像',
    image_url: '镜像地址',
    repository: '镜像仓库',
    success: '操作成功',
    failed: '操作失败',
    usageEcs: 'ECS',
    usageTrain: '训练',
    usageDeploy: '推理',
    usageAll: '通用',
    build_image: '构建镜像',
    placeholder: '选择镜像',
  },
  resource_spec_table: {
    name: '名称',
    gpu_name: 'GPU名称',
    gpu_mem: 'GPU显存',
    gpu_num: 'GPU数量',
    cpu_name: 'CPU名称',
    cpu_num: 'CPU核数',
    cpu_arch: 'CPU架构',
    mem_size: '内存大小',
    extras: '其它',
    available: '可用数量',
    postPaidPrice: '现价/原价（每小时）',
  },
  server_spec: {
    create: '创建节点规格',
    edit: '编辑',
    delete: '删除',
    delete_action: '删除节点规格',
    disk_size: '磁盘',
    disk_type: '磁盘类型',
    created_at: '创建时间',
    updated_at: '更新时间',
    operation: '操作',
  },
  // DiskList.tsx
  diskList: {
    label: {
      nameAndId: '名称 / ID',
      alias: '别名',
      permission: '权限',
      storageCluster: '存储集群',
      size: 'Size',
      readOnly: '只读',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      action: '操作',
    },
    action: {
      createDisk: '创建磁盘',
      deleteDiskWithName: '删除磁盘: {{name}}',
    },
    placeholder: {
      search: '搜索磁盘名称',
    },
  },
  // ClusterWorkloadList.tsx
  clusterWorkloadList: {
    columns: {
      id: 'ID',
      queueName: '队列名称',
      resourceSpecName: '规格名称',
      userName: '用户名',
      project: '项目',
      status: '状态',
      createdAt: '创建时间',
      updatedAt: '更新时间',
    },
    filters: {
      resourceType: {
        label: '资源类型',
        all: '全部',
        shared: '共享资源',
        exclusive: '专属资源',
      },
      type: {
        label: '类型',
        ecs: 'ECS',
        train: '训练',
        deployment: '推理',
      },
      status: {
        label: '状态',
        all: '全部',
        running: '运行中',
        stopped: '已停止',
        init: '初始化',
        failed: '失败',
        success: '成功',
      },
      search: '搜索',
    },
  },
  // DeploymentHpaEditor.tsx
  DeploymentHpaEditor: {
    targetUtilizationRequired: '请输入目标利用率',
    minReplicasRequired: '请输入最小实例数',
    maxReplicasRequired: '请输入最大实例数',
    targetUtilizationRange: '请输入目标利用率',
    targetMetricRequired: '请选择目标指标',
    minReplicasGreaterThanMax: '最小实例数不能大于最大实例数',
  },
  // ClusterWorkloadStats.tsx
  ClusterWorkloadStats: {
    projectId: '项目ID',
    project: '项目',
    cpu: 'CPU',
    memory: '内存',
    operation: '操作',
  },
  // ClusterForm.tsx
  ClusterForm: {
    ingressPort: '流量入口端口',
    ingressPortTooltip: '集群对外暴露的流量入口端口号，用于外部访问集群服务',
  },
  // DatasetList.tsx
  DatasetList: {
    gitRepoPlaceholder: '请输入 Git 仓库地址',
    gitRepoRequired: '请输入 Git 仓库地址',
  },
  // DeploymentPodList.tsx
  DeploymentPodList: {
    name: '名称',
    status: '状态',
    node: '节点',
    ip: 'IP',
    startTime: '开始时间',
    operation: '操作',
  },
  // EnvEditor.tsx
  EnvEditor: {
    nameRequired: '变量名称不能为空',
    namePlaceholder: '环境变量名称',
    descriptionPlaceholder: '环境变量描述',
    valuePlaceholder: '环境变量值',
  },
  // ImageForm.tsx
  ImageForm: {
    env: '环境变量',
    envTooltip: '设置镜像默认的环境变量，容器启动时将自动加载这些变量',
  },
  // InspectionList.tsx
  InspectionList: {
    ingressFails: '域名接入',
    serviceFails: '服务访问',
    podFails: '工作负载',
    abnormal: '异常',
    normal: '正常',
    inspection: '巡检',
    createInspection: '发起巡检',
    id: 'ID',
    status: '状态',
    inspectionInfo: '巡检信息',
    dashboard: '监控大盘',
    startTime: '开始时间',
    endTime: '结束时间',
    view: '查看',
  },
  // InstancePortsEditor.tsx
  InstancePortsEditor: {
    editPorts: '编辑端口',
    updatePortsSuccess: '更新端口成功！',
    updatePortsFailed: '更新端口失败！',
  },
  LabelEditor: {
    nameRequired: '标签名称不能为空',
    namePlaceholder: '标签名称',
    valuePlaceholder: '标签值',
  },
  // PortsEditor.tsx
  PortsEditor: {
    nameRequired: '端口名称不能为空',
    nameInvalid: '端口名称只能包含小写字母、数字和连字符',
    nameDuplicate: '端口名称不能重复',
    portRange: '端口号必须在1-65535之间',
    targetPortRange: '目标端口号必须在1-65535之间',
    namePlaceholder: '端口名称',
    portPlaceholder: '端口号',
    targetPortPlaceholder: '目标端口号',
  },
  // LogViewer.tsx
  LogViewer: {
    log: '日志',
    loginContainer: '登录容器',
    refreshLog: '刷新日志',
    scrollToBottom: '滚动到最后',
    noLog: '暂无日志',
  },
  // ModelForm.tsx
  ModelForm: {
    editModel: '编辑模型',
    createModel: '创建模型',
  },
  // QueueForm.tsx
  QueueForm: {
    reclaimStrategy: '主动资源回收策略',
    reclaimStrategyTooltip: '主动对低利用率的资源进行回收，当资源利用率低于阈值x%持续y分钟时，主动停止工作负载以回收资源',
    thresholdRequired: '请输入阈值',
    threshold: '阈值',
    durationRequired: '请输入时长(分钟)',
    duration: '时长',
    minutes: '分钟',
    enabledRequired: '请选择是否启用',
    enabledPlaceholder: '请选择是否启用',
  },
  // QueueResourceEditor.tsx
  QueueResourceEditor: {
    nameRequired: '资源名称不能为空',
    nameDuplicate: '资源名称重复',
    namePlaceholder: '资源名称',
    quantityPlaceholder: '资源数量',
  },
  // QueueSelector.tsx
  QueueSelector: {
    running: '运行中',
    pending: '等待中',
    inQueue: '排队中',
    all: '全部',
    jobStatus: '作业状态',
    remainingResources: '剩余资源',
    noAvailableQueue: '无可用资源队列',
  },
  // RechargeForm.tsx
  RechargeForm: {
    rechargeSuccess: '充值成功！',
    rechargeFailed: '充值失败！',
    rechargeAmount: '充值金额',
    recharge: '充值',
    yuan: '元',
  },
  // ResourceSpecDisplay.tsx
  ResourceSpecDisplay: {
    gpu: 'GPU',
    cpu: 'CPU',
    cores: '核',
    memory: '内存',
  },
  // SaveImageBtn.tsx
  SaveImageBtn: {
    saveImage: '保存镜像',
    updateImage: '更新镜像',
    createImage: '创建镜像',
  },
  // ServerSpec/Form.tsx
  ServerSpecForm: {
    updateServerSpec: '更新计算节点',
    createServerSpec: '创建计算节点',
    name: '名称',
    gpuVendor: 'GPU 厂商',
    gpuName: 'GPU 名称',
    gpuNum: 'GPU 数量',
    gpuMem: 'GPU 内存',
    gpuSpp: 'GPU SPP',
    gpuDpp: 'GPU DPP',
    maxCuda: '最大 CUDA 版本',
    cpuNum: 'CPU 数量',
    cpuName: 'CPU 名称',
    memSize: '内存大小',
    diskSize: '磁盘大小',
    diskType: '磁盘类型',
  },
  // ServerSpec/Selector.tsx
  ServerSpecSelector: {
    gpu: 'GPU',
    cpu: 'CPU',
    cores: '核',
    memory: '内存',
  },
  // StorageClusterDiskList.tsx
  StorageClusterDiskList: {
    id: 'ID',
    alias: '别名',
    permission: '权限',
    storageCluster: '存储集群',
    capacity: '容量',
    used: '已使用',
    readOnly: '只读',
    yes: '是',
    no: '否',
    user: '用户',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    search: '搜索',
  },
  // StorageClusterForm.tsx
  StorageClusterForm: {
    cephPathTooltip: '集群在文件系统中的路径，例如：/',
    localPathTooltip: '本地存储路径，例如：/var/lib/trainkr',
    loongstorePathTooltip: '集群在文件系统中的路径，例如：/',
    defaultPathTooltip: '数据存储的默认路径，用于存放用户的磁盘和数据文件',
    mountPath: '挂载路径',
    clusterPath: '集群路径',
    loongstoreApiConfig: 'LoongStore API配置',
    configDescription: '配置说明',
    loongstoreConfigDesc: 'LoongStore需要配置API连接参数和挂载路径。请确保所有计算节点已正确挂载LoongStore文件系统。',
    apiServer: 'API服务器',
    apiServerTooltip: 'LoongStore API服务器地址，不包含http://或https://前缀',
    apiServerPlaceholder: 'loongstore.example.com',
    usernameResourcePool: '用户名/资源池',
    usernameResourcePoolTooltip: 'LoongStore用户名，同时用作资源池名称',
    usernamePlaceholder: 'admin',
    apiPassword: 'API密码',
    apiPasswordTooltip: 'LoongStore API认证密码',
    apiPasswordPlaceholder: '请输入API密码',
    apiClientId: 'API客户端ID',
    apiClientIdTooltip: 'LoongStore OAuth2认证的客户端ID，用于API鉴权',
    apiClientSecret: 'API客户端密钥',
    apiClientSecretTooltip: 'LoongStore OAuth2认证的客户端密钥，用于API鉴权',
    computeNodeMountPath: '计算节点挂载路径',
    computeNodeMountPathTooltip: 'LoongStore文件系统在计算节点上的挂载路径，例如：/datapool',
    computeNodeMountPathPlaceholder: '/datapool',
  },
  // StorageClusterStats.tsx
  StorageClusterStats: {
    projectId: '项目ID',
    project: '项目',
    diskCount: '磁盘数量',
    totalCapacity: '总容量',
    used: '已使用',
    userId: '用户ID',
    userName: '用户名',
    operation: '操作',
    view: '查看',
  },
  // ResourceSelectorItems.tsx
  ResourceSelectorItems: {
    currentPricePerHour: '现价/原价（每小时）',
  },
  // StorageResourceQuotaList.tsx
  StorageResourceQuotaList: {
    quotaType: '配额类型',
    storageDisk: '存储磁盘',
    imageRegistry: '镜像仓库',
    domain: '域',
    project: '项目',
    user: '用户',
    storageClusterOrRegistry: '存储集群 / 镜像仓库',
    storageSize: '存储大小',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    operation: '操作',
    edit: '编辑',
    delete: '删除',
    createResourceQuota: '创建资源配额',
    search: '搜索',
  },
  importTaskMonitor: {
    stopImport: '停止导入',
    stopImportConfirmTitle: '确定要停止导入吗？',
    stopImportConfirmDesc: '将终止集群中的导入任务，资源会标记为导入失败；可稍后重新发起导入。',
    stopImportOk: '停止',
    importStopped: '已中止导入',
  },
  // VolumeMountsEditor.tsx
  VolumeMountsEditor: {
    mountPathRequired: '挂载路径不能为空',
    mountPathInvalid: '挂载路径格式不正确，以「/」开头，不能以「/」结尾',
    mountResourceRequired: '挂载资源不能为空',
    disk: '存储盘',
    dataset: '数据集',
    model: '模型',
  },
}

export default translation
